import { FlightPaymentType } from '@customTypes/types';
import { z } from 'zod';

import { VALIDATE } from '@/shared/constants/validation';

export const contractTermsSchema = z.object({
  data: z.object({
    minContractDurationWeeks: VALIDATE.MINIMAL_CONTRACT_DURATION,
    artistWorkSchedule: VALIDATE.REQUIRED,
    flightPaymentType: z.nativeEnum(FlightPaymentType),
    compensationForOneMonth: z.number().optional(),
    compensationForTwoMonths: z.number().optional(),
    compensationForThreeMonths: z.number().optional(),
    freeReturnTicketAfterSixMonths: z.boolean(),
    isTransferOrganizedByClub: z.boolean()
  })
});
